"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarEventSchemaProperties = exports.CalendarEventSchema = exports.ResponseStatus = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const integration_1 = require("./integration");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.ResponseStatus = zod_1.z.enum(["accepted", "declined", "pending"]);
const AttendeeSchema = zod_1.z.object({
    email: zod_1.z.string(),
    responseStatus: exports.ResponseStatus,
});
exports.CalendarEventSchema = base_schema_1.BaseSchema.extend({
    // Globally unique identifier
    vendorId: zod_1.z.string(),
    uid: zod_1.z.string(),
    provider: integration_1.ProviderSchema,
    aid: zod_1.z.string(),
    subject: zod_1.z.string().nullable(),
    description: zod_1.z.string(),
    organizerEmail: zod_1.z.string(),
    attendees: AttendeeSchema.array(),
    location: zod_1.z.string().optional().nullable(),
    conferenceData: zod_1.z
        .object({
        url: zod_1.z.string(),
        provider: zod_1.z.string(),
    })
        .optional(),
    cancelled: zod_1.z.boolean(),
    status: exports.ResponseStatus,
    start: zod_1.z.date(),
    end: zod_1.z.date(),
    metadata: zod_1.z.any().optional().nullable(),
    recurringEventId: zod_1.z.string().optional().nullable(),
    allDayEvent: zod_1.z.boolean().optional().nullable(),
    calendarId: zod_1.z.string(),
    vendorData: zod_1.z.any(),
    blocking: zod_1.z.boolean().optional().nullable(),
});
exports.CalendarEventSchemaProperties = {
    collectionName: "calendarEvents",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=calendar-event-schema.js.map